<h2 mat-dialog-title>Delete Current Device?</h2>
<mat-dialog-content class="mat-dialog-content"> {{device.name}} </mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button [mat-dialog-close]="true" mat-button id="deviceDeleteYes">Yes</button>
    <button [mat-dialog-close]="false" mat-button id="deviceDeleteNo">No</button>
</mat-dialog-actions>
